<template>
  <v-bottom-sheet v-model="sheet">
    <v-list>
      <v-subheader v-text="title"></v-subheader>

      <v-list-item
        v-for="item in list"
        :key="item.code"
        @click="execute(item.action)"
      >
        <v-list-item-icon v-if="item.icon">
          <v-icon v-text="item.icon"></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="item.title" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-bottom-sheet>
</template>

<script>
export default {
  data() {
    return {
      sheet: false,
      list: [],
      title: ""
    };
  },

  methods: {
    open(title, list) {
      this.title = title;
      this.list = list;
      this.sheet = true;
    },

    async execute(action) {
      if (action) {
        await action();
      }
      this.sheet = false;
    }
  }
};
</script>
